// extracted by mini-css-extract-plugin
module.exports = {"not-found-view":"not-found__not-found-view___3OaXx"};